import { State } from "../state";

export type SetEditingTableAction = Readonly<{
  type: "SET EDITING TABLE";
  zoneIndex: number | null;
}>;

export const setEditingTable = (state: State, action: SetEditingTableAction): State => {
  return {
    ...state,
    editTable: action.zoneIndex
  };
};
